import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview"]

  select(event){
    this.previewTarget.setAttribute("src", event.target.getAttribute("src"))
  }
}
